import React, { useEffect, useRef, useState } from "react";
import Loader, { LocalStorage } from "../../../utils/Utils";
import BackgroundLightBlueContainer from "../../recommendation/recommendation_industry_view/components/Background_Container";
import { Col, Container, Row } from "react-bootstrap";
import BlueHorizontalDivider from "../../recommendation/recommendation_industry_view/components/Blue_Horizontal_Divider";
import BlueVerticalDivider from "../../recommendation/recommendation_industry_view/components/Blue_Vertical_Divider";
import "../styles/LearingRoomViewPageStyles.css";
import NewImage from "../../recommendation/recommendation_industry_view/components/New_Image";
import VideoImageOverlay from "../../recommendation/recommendation_industry_view/components/VideoImage_Overlay";
import { useNavigate, useLocation } from "react-router-dom";
import { useApi } from "../../../service/ApiContext";
import RecommendationIndustryViewClient from "../../recommendation/recommendation_industry_view/data/api_client/Recommendation_IndustryView_Client";
import {
  CourseTopic,
  CourseTopicListResponse,
} from "../../recommendation/recommendation_industry_view/data/response/Course_Topic_Response";
import {
  TopicVideoResponse,
  VideoListResponse,
} from "../../recommendation/recommendation_industry_view/data/response/Topic_Videos_Response";
import strings from "../../../utils/Strings";
import {
  NoRecordsFound,
  NoTopicsFound,
} from "../../recommendation/recommendation_industry_view/components/NoRecords_Found";
import CommonUtils from "../../../utils/Common_Utils";
import Logger from "../../../utils/Logger";
import {
  LabSessionVideoResponse,
  LabVideoListResponse,
} from "../../recommendation/recommendation_industry_view/data/response/Lab_Session_Response";
import { logActionEvent } from "../../../analytics/analytics_utils";
import analytics_strings from "../../../analytics/analytics_strings";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { TopicNameTitleTextComponent } from "../../recommendation/recommendation_industry_view/components/TopicNameTittleText";
import {
  setQuizComponentActive,
  setQuizOverlayActive,
} from "../../recommendation/vedio-recommendation/data/redux/QuizLogoutRedux";
import PDFIcon from "../../recommendation/assets/images/pdf.png";
import GreyHorizontalDivider from "../components/GreyDividerComponent";
import LearningRoomViewHeader from "../components/LearningRoomViewHeader";
import { Collapse } from "reactstrap";
import arrowImg from "../../recommendation/assets/images/JozunaView/arrowImg.png"; // Import the image
import {
  clearLRState,
  setLRLabClick,
  setLRSelectedItem,
  setLRTopicDetailedIndex,
} from "../data/redux/LearningRoomRedux";
import VideoCard from "../components/VideoOverlayCard";

interface LearningRoomViewPageProps {
  course_id: string;
  course_name: string;
  program_id: string;
  program_description?: string;
  program_title?: string;
}
// const LearningRoomViewPage: React.FC<LearningRoomViewPageProps> = ({
//   course_id,
//   course_name,
//   program_id,
//   program_description,
//   program_title,
// }) => {
const LearningRoomViewPage: React.FC = () => {
  // Declarations
  const api = useApi();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    course_id,
    course_name,
    program_id,
    program_description,
    program_title,
  } = location.state || {};
  const state = {
    course_id,
    course_name,
    program_id,
    program_description,
    program_title,
  };
  //Initial Method
  useEffect(() => {
    getLabTopicVideos(state.course_id);
    getCourseTopic(state.course_id);
  }, [course_id]);
  // Select the data from the Redux store
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  //Variable Declaration
  const [selectedItem, setSelectedItem] = useState<CourseTopic | null>();
  const [topicduration, setTopicduration] = useState<number>();
  // const [videoduration, setVideoduration] = useState<number>();
  const [topicList, setTopicList] = useState<CourseTopic[]>();
  const [videoData, setVideoData] = useState<TopicVideoResponse | null>();
  // const [labClick, setLabClick] = useState<boolean>(false);
  const [labData, setLabData] = useState<LabSessionVideoResponse>();
  const [totVideos, setTotVideos] = useState(null);
  const [totFiles, setTotFiles] = useState(null);
  const [openDetailIndex, setOpenDetailIndex] = useState<
    number | string | null
  >(null);
  const handleToggle = (index: number | string) => {
    setOpenDetailIndex((prev) => (prev === index ? null : index));
    dispatch(setLRTopicDetailedIndex(index));
  };
  // const [labSelectedItem, labSetSelectedItem] =
  //   useState<LabVideoListResponse | null>();
  const dispatch = useDispatch();
  const reduxInitialdata = useSelector(
    (state: RootState) => state.learningRoom,
  );
  const reduxselectedItem = useSelector(
    (state: RootState) => state.learningRoom.selectedItem,
  );
  const topicDetailedIndex = useSelector(
    (state: RootState) => state.learningRoom.topicDetailedIndex,
  );
  const labClick = useSelector(
    (state: RootState) => state.learningRoom.labClick,
  );
  //Methods
  const handleItemClick = (item: CourseTopic, index: number | string) => {
    dispatch(setLRSelectedItem(item));
    dispatch(setLRTopicDetailedIndex(index));
    setOpenDetailIndex(index);
    setSelectedItem(item);
    getTopicVideos(item.topic_id);
  };
  const isTopicCompleted = (labData: LabSessionVideoResponse) => {
    return labData.videos.every((subTopic) =>
      subTopic.list_videos.every(
        (video) => video.completion_status === "Completed",
      ),
    );
  };

  //Api Calls
  const getCourseTopic = async (courseId: string) => {
    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<CourseTopicListResponse>(
        RecommendationIndustryViewClient.getCourseToipcUrl,
        {
          course_id: courseId,
          program_id: state.program_id,
          program_category: "Industry",
        },
      );
      setTotVideos(response.data.total_videos ?? null); // ✅ Ensuring a falsy value when key is missing
      setTotFiles(response.data.total_files ?? null); // ✅ Ensuring a falsy value when key is missing

      setTopicList(response.data.list_topics);
      setTopicduration(response.data.total_duration);
      if (response.data.list_topics.length !== 0 && labClick !== true) {
        if (
          reduxInitialdata !== null &&
          topicDetailedIndex !== null &&
          reduxInitialdata !== undefined &&
          reduxselectedItem !== null
        ) {
          handleItemClick(reduxselectedItem, topicDetailedIndex);
        } else {
          handleItemClick(response.data.list_topics[0], 0);
        }
      }
    } catch (error) {
      Logger.error("Error fetching Course Topics:", error);
    } finally {
      Loader.dismissLoading();
    }
  };
  const getLabTopicVideos = async (courseId: string) => {
    dispatch(setLRLabClick(true));
    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    try {
      const response = await api.get<LabSessionVideoResponse>(
        `${RecommendationIndustryViewClient.labSession}?course_id=${courseId}`,
      );
      setLabData(response.data);
      // labSetSelectedItem(response.data)
    } catch (error) {
      Logger.error("Error fetching Lab Topic Videos:", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const getTopicVideos = async (topicId: string) => {
    dispatch(setLRLabClick(false));
    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<TopicVideoResponse>(
        RecommendationIndustryViewClient.getCourseVideoUrl,
        {
          course_id: state.course_id,
          topic_id: topicId,
          program_id: state.program_id,
          program_category: "Industry",
        },
      );
      setVideoData(response.data);

      // setVideoduration(response.data.total_duration);
    } catch (error) {
      setVideoData(null);
      Logger.error("Error fetching Course Videos:", error);
    } finally {
      Loader.dismissLoading();
    }
  };
  //Header Value showing
  const selectedProgramTitle = useSelector(
    (state: RootState) => state.dropdown.selectedProgram?.title,
  );
  const selectedTopicTitle = useSelector(
    (state: RootState) => state.learningRoom.selectedItem,
  );

  // const active = 1;
  return (
    <div>
      <div className="desktop-ui_assessmentCheck">
        <div
          className="learningroomlanding-page"
          style={{
            backgroundColor: "#F5F5F5",
            height:
              LocalStorage.getLocalData("fromFlutter") !== "true"
                ? "90vh"
                : "100vh",
          }}
        >
          <LearningRoomViewHeader
            text={`${state?.program_title ?? selectedProgramTitle} > ${state?.course_name}`}
            isVideoPage={false}
            onClick={() => {
              dispatch(clearLRState());
              navigate("/dashboard/learning-room");
            }}
          />
          <Container fluid className="h-100">
            <Row
              style={{
                paddingTop: "10px",
                paddingLeft: "10px",
                paddingRight: "15px",
              }}
            >
              <Col
                xs={3}
                md={3}
                lg={3}
                // className="left-column"
              >
                <div className="videos-content-grid">
                  {topicList?.length ? (
                    topicList.map((topic, index) => (
                      <div key={index} style={{ width: "100%" }}>
                        <div
                          onClick={() => {
                            handleToggle(index);
                            dispatch(setLRLabClick(false));

                            // if (openDetailIndex !== index) {
                            handleItemClick(topic, index); // fetch topic videos
                            // }

                            // dispatch(setLRSelectedItem(null));
                            // dispatch(setLRTopicDetailedIndex(null));
                            setSelectedItem(topic);

                            // dispatch(setLRCourseSelectedItem(data));
                          }}
                          // className={`learningroom-list-item ${
                          //   selectedItem?.course_id === data.course_id
                          //     ? "selected"
                          //     : ""
                          // } ${data.completion_status === "Completed" ? "completed" : ""} ${
                          //   !data.has_videos ? "disabled" : ""
                          // }`}
                          className={`learningroom-list-item ${
                            selectedItem?.topic_id === topic.topic_id
                              ? "selected"
                              : topic.completion_status === "Completed"
                                ? "completed"
                                : ""
                          }`}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "start",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                justifyContent: "space-between",
                                width: "100%",
                                paddingRight: "15px",
                              }}
                            >
                              <TopicNameTitleTextComponent
                                title={topic.topic_title}
                              />
                              {/* {data.is_new && (
                              <img
                                alt="Additional Icon"
                                src={NewIcon}
                                className="additionals-image"
                              />
                            )} */}
                            </div>

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "8px",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <p
                                className="list-child"
                                style={{ fontSize: "0.8rem" }}
                              >
                                {topic.number_of_videos}{" "}
                                {topic.number_of_videos > 1
                                  ? "videos"
                                  : "video"}
                                {" , "}
                                {topic.number_of_files}{" "}
                                {topic.number_of_files > 1
                                  ? "Documents"
                                  : "Document"}
                              </p>
                              {topic.is_new == true && <NewImage />}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <NoTopicsFound />
                  )}
                  {/* Lab Session */}
                  {labData && labData?.videos?.length > 0 && (
                    <div style={{ width: "100%" }}>
                      <div
                        className={`learningroom-list-item ${
                          // selectedItem?.topic_id === labData.topic_id
                          labClick === true
                            ? "selected"
                            : isTopicCompleted(labData)
                              ? "completed"
                              : ""
                        }`}
                      >
                        <div
                          // className={`list-item ${
                          //   openDetailIndex === "lab" ? "selected" : ""
                          // }`}
                          onClick={async () => {
                            handleToggle("lab");
                            dispatch(setLRSelectedItem(null));
                            dispatch(setLRTopicDetailedIndex(null));
                            setSelectedItem(null);
                            // if (openDetailIndex !== "lab") {
                            dispatch(setLRLabClick(true));

                            await getLabTopicVideos(state.course_id);

                            // }
                          }}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "start",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              justifyContent: "space-between",
                              width: "100%",
                              paddingRight: "15px",
                            }}
                          >
                            <TopicNameTitleTextComponent title="Lab Session" />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "8px",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <p
                              className="list-child"
                              style={{ fontSize: "0.8rem" }}
                            >
                              {labData.number_of_videos}{" "}
                              {labData.number_of_videos > 1
                                ? "videos"
                                : "video"}
                            </p>
                            {labData?.videos?.some((video) =>
                              video.list_videos.some((item) => item.is_new),
                            ) && <NewImage />}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Col>
              <Col
                // lg={8}
                xs={9}
                md={9}
                lg={9}
                // className="py-0 d-flex flex-column"
                style={{
                  height: "85vh",
                  overflowY: "auto",
                }}
              >
                <div className="video-grid-lr">
                  {labClick !== true &&
                    (videoData &&
                    videoData?.videos[0]?.list_videos.length > 0 ? (
                      videoData?.videos[0]?.list_videos?.map((item, index) => (
                        <VideoCard
                          postedonDate={item.video_posted_on}
                          title={
                            item.content_type === "video"
                              ? item.video_title
                              : item.file_title!
                          }
                          videoUrl={
                            item.content_type === "video"
                              ? item.video_thumbnail
                              : PDFIcon
                          }
                          newFlag={item.is_new}
                          width={
                            item.content_type === "video" ? "100%" : "100%"
                          }
                          height="150px"
                          playBtnheight={
                            item.content_type === "video" ? "43px" : "0px"
                          }
                          playBtnwidth={
                            item.content_type === "video" ? "56px" : "0px"
                          }
                          content_type={item.content_type}
                          // isDocument={item.content_type === "file"}
                          completionStatus={item.completion_status}
                          // completed={item.completion_status === "Completed"}
                          onClick={() => {
                            navigate(
                              "/dashboard/learning-room/view-courses/video",
                              {
                                state: {
                                  video_id: item.video_id, // For initial video to play
                                  topic_id: selectedItem?.topic_id, // Videos topic id
                                  video_list: videoData.videos[0].list_videos, // videoData for video thumbnail & video id
                                  course_name: state.course_name, // Course name
                                  course_id: state.course_id, // Course ID
                                  course_topic: selectedItem?.topic_title, // Videos topic title
                                  program_id: state.program_id,
                                  program_category: "Industry",
                                  labSession: false, // Indicates it's not a lab session
                                  //state Header values
                                  selectedProgramTitle:
                                    selectedProgramTitle ?? state.program_title,
                                  selectedTopicTitle:
                                    selectedTopicTitle?.topic_title,
                                },
                              },
                            );
                          }}
                        />
                      ))
                    ) : (
                      <NoRecordsFound />
                    ))}
                  {labClick === true &&
                    (labData && labData.videos && labData.videos.length > 0 ? (
                      labData.videos[0]?.list_videos?.map((item) => (
                        <VideoCard
                          postedonDate={item.video_posted_on}
                          title={item.video_title}
                          videoUrl={item.video_thumbnail}
                          newFlag={item.is_new}
                          width="100%"
                          height="150px"
                          playBtnheight="43px"
                          playBtnwidth="56px"
                          content_type={"video"}
                          // isDocument={item.content_type === "file"}
                          completionStatus={item.completion_status}
                          // completed={item.completion_status === "Completed"}
                          onClick={() => {
                            logActionEvent(
                              analytics_strings.analytics_events.lab_session,
                              {
                                candidate_id: userData.candidate_id,
                                course_name: state.course_name,
                                video_name: item.video_title,
                              },
                            );
                            navigate(
                              "/dashboard/learning-room/view-labsession/video",
                              {
                                state: {
                                  video_id: item.video_id, // For initial video to play
                                  topic_id: item.topic_id, // Videos topic id
                                  video_list: labData.videos[0].list_videos, // labData for video thumbnail & video id
                                  course_name: state.course_name, // Course name
                                  course_id: state.course_id, // Course ID
                                  course_topic: selectedItem?.topic_title, // Videos topic title
                                  program_id: state.program_id,
                                  program_category: "Industry",
                                  labSession: true, // Indicates it's a lab session
                                  //state Header values
                                  selectedProgramTitle:
                                    selectedProgramTitle ?? state.program_title,
                                  selectedTopicTitle:
                                    selectedTopicTitle?.topic_title,
                                },
                              },
                            );
                          }}
                        />
                      ))
                    ) : (
                      <NoRecordsFound />
                    ))}
                </div>
                {/* {topicList?.length ? (
                  topicList.map((topic, index) => (
                    <div key={topic.topic_id} className="mb-3">
                      <div
                        style={{
                          backgroundColor:
                            topic.completion_status === "Completed"
                              ? "#dcffda"
                              : "#E7EFFF",
                          borderRadius: "24px",
                          padding: "20px",
                        }}
                      >
                        <div
                          onClick={async () => {
                            handleToggle(index);

                            if (openDetailIndex !== index) {
                              handleItemClick(topic, index); // fetch topic videos
                            }
                          }}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: 10,
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <TopicNameTitleTextComponent
                              title={topic.topic_title}
                            />
                            {topic.is_new == true && <NewImage />}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: 15,
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <p
                              className="list-child"
                              style={{ fontSize: "0.8rem" }}
                            >
                              {topic.number_of_videos}{" "}
                              {topic.number_of_videos > 1 ? "videos" : "video"}
                              {" , "}
                              {topic.number_of_files}{" "}
                              {topic.number_of_files > 1
                                ? "Documents"
                                : "Document"}
                            </p>
                            <img
                              src={arrowImg}
                              alt="Toggle"
                              style={{ height: "9px", width: "16px" }}
                            />
                          </div>
                        </div>

                        <Collapse isOpen={openDetailIndex === index}>
                          {videoData &&
                          videoData.videos &&
                          videoData.videos[0]?.list_videos?.length > 0 ? (
                            <Row
                              style={{
                                backgroundColor:
                                  topic.completion_status === "Completed"
                                    ? "#dcffda"
                                    : "#E7EFFF",
                                // backgroundColor: "#E7EFFF",
                                borderRadius: "20px",
                                padding: "15px",
                                marginTop: "10px",
                              }}
                            >
                              {videoData?.videos?.[0]?.list_videos?.map(
                                (item) => (
                                  <Col
                                    xs={12}
                                    md={4}
                                    key={item.video_id}
                                    className="mb-4"
                                  >
                                    <div>
                                      <VideoImageOverlay
                                        videoUrl={
                                          item.content_type === "video"
                                            ? item.video_thumbnail
                                            : PDFIcon
                                        }
                                        newFlag={item.is_new}
                                        width={
                                          item.content_type === "video"
                                            ? "100%"
                                            : "50%"
                                        }
                                        height="150px"
                                        playBtnheight={
                                          item.content_type === "video"
                                            ? "43px"
                                            : "0px"
                                        }
                                        playBtnwidth={
                                          item.content_type === "video"
                                            ? "56px"
                                            : "0px"
                                        }
                                        onClick={() =>
                                          navigate(
                                            "/dashboard/learning-room/view-courses/video",
                                            {
                                              state: {
                                                video_id: item.video_id, // For initial video to play
                                                topic_id:
                                                  selectedItem?.topic_id, // Videos topic id
                                                video_list:
                                                  videoData.videos[0]
                                                    .list_videos, // videoData for video thumbnail & video id
                                                course_name: state.course_name, // Course name
                                                course_id: state.course_id, // Course ID
                                                course_topic:
                                                  selectedItem?.topic_title, // Videos topic title
                                                program_id: state.program_id,
                                                program_category: "Industry",
                                                labSession: false, // Indicates it's not a lab session
                                                //state Header values
                                                selectedProgramTitle:
                                                  selectedProgramTitle,
                                                selectedTopicTitle:
                                                  selectedTopicTitle?.topic_title,
                                              },
                                            },
                                          )
                                        }
                                      />

                                      <div className="mt-2">
                                        <TruncatedTitle
                                          title={
                                            item.content_type === "video"
                                              ? item.video_title
                                              : item.file_title!
                                          }
                                          onClick={() =>
                                            navigate(
                                              "/dashboard/learning-room/view-courses/video",
                                              {
                                                state: {
                                                  video_id: item.video_id, // For initial video to play
                                                  topic_id:
                                                    selectedItem?.topic_id, // Videos topic id
                                                  video_list:
                                                    videoData.videos[0]
                                                      .list_videos, // videoData videos
                                                  course_name:
                                                    state.course_name, // Course name
                                                  course_id: state.course_id, // Course ID
                                                  course_topic:
                                                    selectedItem?.topic_title, // Videos topic title
                                                  program_id: state.program_id,
                                                  program_category: "Industry",
                                                  labSession: false, // Indicates it's not a lab session
                                                  //state Header values
                                                  selectedProgramTitle:
                                                    selectedProgramTitle,
                                                  selectedTopicTitle:
                                                    selectedTopicTitle?.topic_title,
                                                },
                                              },
                                            )
                                          }
                                        />
                                        <p
                                          style={{ fontSize: "0.8rem" }}
                                          className="image-child"
                                        >
                                          Posted on{" "}
                                          {CommonUtils.formatAllRegionDate(
                                            item.video_posted_on,
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </Col>
                                ),
                              )}
                            </Row>
                          ) : (
                            <NoRecordsFound />
                          )}
                        </Collapse>
                      </div>
                    </div>
                  ))
                ) : (
                  <NoTopicsFound />
                )}

                {labData && labData?.videos?.length > 0 && (
                  <div className="mt-3">
                    <div
                      style={{
                        backgroundColor: "#E7EFFF",
                        borderRadius: "24px",
                        padding: "20px",
                      }}
                    >
                      <div
                        // className={`list-item ${
                        //   openDetailIndex === "lab" ? "selected" : ""
                        // }`}
                        onClick={async () => {
                          handleToggle("lab");

                          if (openDetailIndex !== "lab") {
                            setLabClick(true);
                            await getLabTopicVideos(state.course_id);
                          }
                        }}
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 10,
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <TopicNameTitleTextComponent title="Lab Session" />
                          {labData?.videos?.some((video) =>
                            video.list_videos.some((item) => item.is_new),
                          ) && <NewImage />}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 15,
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <p
                            className="list-child"
                            style={{ fontSize: "0.8rem" }}
                          >
                            {labData.number_of_videos}{" "}
                            {labData.number_of_videos > 1 ? "videos" : "video"}
                          </p>
                          <img
                            src={arrowImg}
                            alt="Toggle"
                            style={{ height: "9px", width: "16px" }}
                          />
                        </div>
                      </div>

                      <Collapse isOpen={openDetailIndex === "lab"}>
                        {labData &&
                        labData.videos &&
                        labData.videos.length > 0 ? (
                          <Row
                            style={{
                              backgroundColor: "#E7EFFF",
                              borderRadius: "20px",
                              padding: "15px",
                              marginTop: "10px",
                            }}
                          >
                            {labData.videos[0]?.list_videos?.map((item) => (
                              <Col
                                xs={12}
                                md={4}
                                key={item.video_id}
                                className="mb-4"
                              >
                                <VideoImageOverlay
                                  videoUrl={item.video_thumbnail}
                                  newFlag={item.is_new}
                                  width="100%"
                                  height="150px"
                                  playBtnheight="43px"
                                  playBtnwidth="56px"
                                  onClick={() => {
                                    //Mangaing  LabSession on Analytics
                                    logActionEvent(
                                      analytics_strings.analytics_events
                                        .lab_session,
                                      {
                                        candidate_id: userData.candidate_id,
                                        course_name: state.course_name,
                                        video_name: item.video_title,
                                      },
                                    );
                                    navigate(
                                      "/dashboard/learning-room/view-labsession/video",
                                      {
                                        state: {
                                          video_id: item.video_id, // For initial video to play
                                          topic_id: item.topic_id, // Videos topic id
                                          video_list:
                                            labData.videos[0].list_videos, // labData for video thumbnail & video id
                                          course_name: state.course_name, // Course name
                                          course_id: state.course_id, // Course ID
                                          course_topic:
                                            selectedItem?.topic_title, // Videos topic title
                                          program_id: state.program_id,
                                          program_category: "Industry",
                                          labSession: true, // Indicates it's a lab session
                                        },
                                      },
                                    );
                                  }}
                                />

                                <div className="mt-2">
                                  <h1 className="image-title">
                                    {item.video_title}
                                  </h1>
                                  <p
                                    style={{ fontSize: "0.8rem" }}
                                    className="image-child"
                                  >
                                    Posted on{" "}
                                    {CommonUtils.formatAllRegionDate(
                                      item.video_posted_on,
                                    )}
                                  </p>
                                </div>
                              </Col>
                            ))}
                          </Row>
                        ) : (
                          <NoRecordsFound />
                        )}
                      </Collapse>
                    </div>
                  </div>
                )} */}
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div className="mobile-ui_assessmentCheck">
        <p>The LearningRoom is not accessible on mobile devices.</p>{" "}
      </div>
    </div>
  );
  {
    /* <LearningRoomViewHeader
        description={state.program_description}
        text={state.program_title}
        onClick={() => {
          recommendationIndustryViewInstance_Store.clearState();
          navigate("/dashboard/learning-room", { state: { active } });
          dispatch(setQuizOverlayActive(false));
          dispatch(setQuizComponentActive(false));
        }}
      /> */
  }

  {
    /* Course Title */
  }
  {
    /* <h3 className="courseTitle">{`Course: ${state.course_name} `}</h3>

      {totVideos !== null &&
        totVideos !== undefined &&
        totFiles !== null &&
        totFiles !== undefined && (
          // <p className="totalVideos">Total Videos:  {totVideos}</p>
          <p className="totalVideos">
            Total Video{totVideos! > 1 ? "s" : ""}: {totVideos}
            {totFiles !== 0
              ? `, Total File${totFiles! > 1 ? "s" : ""}: ${totFiles}`
              : ""}
          </p>
        )} */
  }
};

export default LearningRoomViewPage;

interface TruncatedTitleProps {
  title: string;
  onClick?: () => void;
}

const TruncatedTitle: React.FC<TruncatedTitleProps> = ({ title, onClick }) => {
  const titleRef = useRef<HTMLHeadingElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = titleRef.current;
    if (el) {
      // Check if content is truncated
      setIsTruncated(el.scrollHeight > el.clientHeight);
    }
  }, [title]);

  return (
    <h1
      ref={titleRef}
      className="image-title"
      style={{
        cursor: "pointer",
        color: "#2d2d2d",
      }}
      title={isTruncated ? title : ""} // ✅ Show tooltip only if truncated
      onClick={onClick}
    >
      {title}
    </h1>
  );
};
